module.exports = __webpack_public_path__ + "rightHover.8ae15f12.png";